import styled from 'styled-components';
import { Trading } from '@stockbit/ui';

const { Slider: BaseSlider } = Trading;

export const Container = styled.div`
  width: 100%;
  padding: 10px;
`;

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`;

export const SliderTrack = styled(BaseSlider)`
  width: 100%;
  margin: 0;
  border-radius: 4px;

  &:hover .ant-slider-handle {
    border-color: #00ab6b !important;
  }

  & > .ant-slider-handle {
    transition: left 0.1s linear;
    will-change: left;

    z-index: 3;
    border-color: #00ab6b;
    box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);

    &:hover {
      border-color: #00ab6b !important;
    }

    :focus {
      box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.09);
    }

    :active {
      box-shadow: 0 0 0 5px rgb(0, 171, 107, 0.12);
    }
  }

  & > .ant-slider-rail {
    display: block;
    z-index: 1;
    background-color: #f1f1f1;
    border-radius: 4px;
  }

  & > .ant-slider-track {
    display: none;
  }
`;

export const TrackWrapper = styled.div<{ cutSize?: number }>`
  z-index: 2;
  cursor: pointer;
  position: absolute;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
  pointer-events: none;
  padding: 4px 0;
  display: flex;

  transition: clip-path 0.1s linear;
  will-change: clip-path;

  & > div {
    border-radius: 0;
    clip-path: polygon(
      calc(0% + ${({ cutSize }) => cutSize}px) 0%,
      100% 0%,
      calc(100% - ${({ cutSize }) => cutSize}px) 100%,
      0% 100%
    );

    :last-child {
      border-radius: 0 4px 4px 0;
      clip-path: polygon(
        calc(0% + ${({ cutSize }) => cutSize}px) 0%,
        100% 0%,
        100% 100%,
        0% 100%
      );
    }

    :first-child {
      border-radius: 4px 0 0 4px;
      clip-path: polygon(
        0% 0%,
        100% 0%,
        calc(100% - ${({ cutSize }) => cutSize}px) 100%,
        0% 100%
      );
    }
  }
`;

export const Track = styled.div<{ width?: number; backgroundColor?: string }>`
  width: ${({ width = 100 }) => width}%;
  background-color: ${({ backgroundColor }) => backgroundColor};
  height: 4px;
  transition: 0.15s background-color ease-out;
`;
